import { configureStore } from "@reduxjs/toolkit";
import adminDataReducer from "./adminSlice";
import staffDataReducer from "./staffSlice";

const store = configureStore({
  reducer: {
    admin: adminDataReducer,
    staff: staffDataReducer,
  },
});

export default store;
